var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"party",class:_vm.size,attrs:{"to":{ name: 'party', params: { partyId: _vm.partyId } }}},[_c('div',{staticClass:"logoWrapper"},[_c('img',{attrs:{"src":`images/parties/${_vm.party.logo}`}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }